import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";

export default function ProfileView({ user, ticketsCount }) {
  return (
    <Card className="support-content-card">
      <CardHeader>
        <CardTitle className="heading-2">
          {user.role === "admin" ? "Infos support" : user.role === "developer" ? "Infos développeur" : "Infos client"}
        </CardTitle>
      </CardHeader>
      <CardContent className="support-profile-stack">
        <div className="support-profile-grid">
          <div className="support-info-card">
            <span className="caption">Nom</span>
            <strong>{user.full_name}</strong>
          </div>
          <div className="support-info-card">
            <span className="caption">Entreprise</span>
            <strong>{user.company_name}</strong>
          </div>
          <div className="support-info-card">
            <span className="caption">Email</span>
            <strong>{user.email}</strong>
          </div>
          <div className="support-info-card">
            <span className="caption">Tickets</span>
            <strong>{ticketsCount}</strong>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
